import { useEffect } from 'react';
import { ApiError } from '@/lib/api-error';
import { forgetChatConversation, rememberChatSpacePath, resolveChatSpaceEntryPath } from '../chat-space-navigation';
import type { ChatSessionIntent } from '../chat-session-intent';

/** Space memory follows the authenticated owner; only definitive refusals evict an id. */
export function useChatSpaceMemory(ownerId: string | undefined, pathname: string, conversationId: string | undefined, error: unknown) {
  useEffect(() => {
    rememberChatSpacePath(ownerId, pathname);
  }, [pathname, ownerId]);
  const status = error instanceof ApiError ? error.status : undefined;
  useEffect(() => {
    if (conversationId && (status === 403 || status === 404)) {
      forgetChatConversation(conversationId);
    }
  }, [conversationId, status]);
  return (intent: ChatSessionIntent) => resolveChatSpaceEntryPath(ownerId, intent);
}
